export interface PublicDesigner {
  user_id: string;
  name: string;
  slug: string;
  salon_name: string | null;
  bio: string | null;
  weekly_schedule: Record<string, [string, string]>;
  region_label: string | null;
  salon_address: string | null;
  specialties: string[];
  career_started_year: number | null;
  instagram_handle?:string; credentials_note?:string; address_visibility?:string;
}

export interface PublicService {
  id: string;
  name: string;
  category: string;
  description: string | null;
  price: number;
  price_max: number | null;
  duration_minutes: number;
  rebooking_interval_weeks: number;
  price_notes?:string[];
  intake_questions: string | Array<{ label: string; required: boolean }>;
}

export interface PublicData {
  rules?: {policy_text:string;cancel_cutoff_hours:number;change_cutoff_hours:number;deposit_amount:number;deposit_note:string};
  designer: PublicDesigner;
  services: PublicService[];
  reviewSummary: { count: number; average: number | null };
  reviews: { id: string; rating: number; comment: string; created_at: string; edited_at?:string;designer_reply?:string }[];
  portfolio: {
    id: string;
    title: string;
    alt_text: string;
    asset_path: string;
    service_id: string | null;
    style_tags: string[];
    pair_group_id?:string; pair_role?:string; is_featured?:number; sort_order?:number;
    created_at: string;
  }[];
}

/**
 * 공개 프로필은 과거에 만들어진 디자이너도 읽는다. 새 선택 필드가 없는 기존 행을
 * 빈 컬렉션으로 정규화해 한 행의 스키마 차이가 예약 화면 전체를 중단하지 않게 한다.
 */
export function normalizePublicBookingData(input: PublicData): PublicData {
  const portfolio = Array.isArray(input.portfolio)
    ? input.portfolio.map((item) => ({
        ...item,
        style_tags: Array.isArray(item.style_tags) ? item.style_tags : [],
      }))
    : [];

  return {
    ...input,
    designer: {
      ...input.designer,
      weekly_schedule:
        input.designer.weekly_schedule &&
        typeof input.designer.weekly_schedule === "object" &&
        !Array.isArray(input.designer.weekly_schedule)
          ? input.designer.weekly_schedule
          : {},
      specialties: Array.isArray(input.designer.specialties)
        ? input.designer.specialties
        : [],
    },
    services: Array.isArray(input.services) ? input.services : [],
    reviewSummary:
      input.reviewSummary && typeof input.reviewSummary.count === "number"
        ? input.reviewSummary
        : { count: 0, average: null },
    reviews: Array.isArray(input.reviews) ? input.reviews : [],
    portfolio,
  };
}
